import { Avatar, AvatarFallback, AvatarImage } from "../atoms";
import { getInitials } from "../lib/utils";

export function UserAvatar({
  user,
  ...rest
}: React.ComponentProps<typeof Avatar> & {
  user?: {
    name?: string | null;
    email?: string | null;
    image?: string | null;
  };
}) {
  return (
    <Avatar {...rest}>
      <AvatarImage
        src={user?.image ?? undefined}
        alt={user?.name ?? user?.email ?? ""}
      />
      <AvatarFallback className="cursor-default">
        {getInitials(user?.name)}
      </AvatarFallback>
    </Avatar>
  );
}
